
<div class="view-component">
    <div class="view-component-title" *ngIf="title!=null">
        <span class="title">{{'menu.'+route.snapshot.data['idMenu']|translateTA}}</span>
    </div>
    <div class="content">
        <div class="tabcontent">
            <nz-spin class="view-spin" [nzSpinning]="loading" nzSize="large">
            @if (realItems.length > 1 ){
                <nz-tabs class="custom-tabs" (nzSelectedIndexChange)="onTabChanged($event)" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (contextmenu)="onRightClick($event)">
                    <ng-container *ngFor="let item of realItems;let index = index" >
                        <nz-tab *ngIf="item.canAccess" [nzTitle]="tabTitleTpl">
                            <ng-template #tabTitleTpl>
                                <div class="tab-header">
                                    <div  class="{{item.iconClass}}" *ngIf="item.iconName!=null" >
                                        <generic-icon [iconName]="item.iconName" [type]="item.iconType"></generic-icon>
                                    </div>
                                    <div class="titleClass">
                                        {{item.titleInstance|translateTA}}
                                    </div>
                                </div>
                            </ng-template>
                            <div class="mktplace" *ngIf="item.type=='treeview'">
                                <simple-datatree [entityName]="item.entityName" [parentRow]="item.parentRow" [condition]="item.condition" [events]="eventsSubject.asObservable()"></simple-datatree>
                            </div>
                            <div class="mktplace" *ngIf="item.type=='gridview'">
                                <simple-datagrid [entityName]="item.entityName" [parentRow]="item.parentRow" [condition]="item.condition" [events]="eventsSubject.asObservable()" [nodata]="item.nodata" [showImageData]="item.showImageData==null?true:item.showImageData" [showImageDataBase64]="item.showImageDataBase64==null?false:item.showImageDataBase64" ></simple-datagrid>
                            </div>
                            <div class="mktplace" *ngIf="item.type=='dashboard'">
                                <main-dashboard [iddashboard]="item.idDashBoard" [events]="eventsSubject.asObservable()" ></main-dashboard>
                            </div>
                            <div class="mktplace" *ngIf="item.type=='component'">
                                <component-factory [component]="item.component" [inputs]="item.properties" [inputFormula]="item.formulaPropriedade" #editComponent></component-factory>
                            </div>
                        </nz-tab>
                    </ng-container>
                </nz-tabs>
                <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen"
                [cdkConnectedOverlayPositions]="positionPairs"
                                            [cdkConnectedOverlayDisableClose]="false"
                                            (detach)="salvarConfig()">
                <div class ="tab-order">
                    <div cdkDropList class="list-order" (cdkDropListDropped)="drop($event)">
                    <div class="list-order-box" *ngFor="let item of realItems" cdkDrag>
                        <div class="list-order-custom-placeholder" *cdkDragPlaceholder></div>
                        <div  class="{{item.iconClass}}" >
                            <generic-icon [iconName]="item.iconName" [type]="item.iconType"></generic-icon>
                        </div>
                        <span>
                            {{item.titleInstance|translateTA}}
                        </span>
                    </div>
                    </div>
                </div>
                </ng-template>
            }@else{
                <ng-container *ngFor="let item of realItems;let index = index" >
                    <div class="mktplace" *ngIf="item.type=='treeview'">
                        <simple-datatree [entityName]="item.entityName" [parentRow]="item.parentRow" [condition]="item.condition" [events]="eventsSubject.asObservable()"></simple-datatree>
                    </div>
                    <div class="mktplace" *ngIf="item.type=='gridview'">
                        <simple-datagrid [entityName]="item.entityName" [parentRow]="item.parentRow" [condition]="item.condition" [events]="eventsSubject.asObservable()" [nodata]="item.nodata" [showImageData]="item.showImageData==null?true:item.showImageData" [showImageDataBase64]="item.showImageDataBase64==null?false:item.showImageDataBase64" ></simple-datagrid>
                    </div>
                    <div class="mktplace" *ngIf="item.type=='dashboard'">
                        <main-dashboard [iddashboard]="item.idDashBoard" [events]="eventsSubject.asObservable()" ></main-dashboard>
                    </div>
                     <div class="mktplace" *ngIf="item.type=='component'">
                            <component-factory [component]="item.component" [inputs]="item.properties" [inputFormula]="item.formulaPropriedade" #editComponent></component-factory>
                    </div>
                </ng-container>
            }
            </nz-spin>
        </div>
    </div>
</div>
